import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'button-toggle-text',
  standalone: true,
  template: `
    <ng-content></ng-content>
  `,
  styles: ``,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'button-toggle-text'
  }
})
export class ButtonToggleTextComponent {}
